<template>
    <!-- 试剂耗材(原生命科学) -->
    <div>
        <contentIndex :initInfo="info"></contentIndex>
    </div>
</template>
<script>
import contentIndex from "./index.vue"
export default {
    components: {
        contentIndex
    },
    data() {
        return {
            info: {
                type: 5,
                testTypeList: [
                    { dictLabel: "全部", dictValue: '' },
                    { dictLabel: "科研耗材", dictValue: '科研耗材' },
                    { dictLabel: "化学试剂", dictValue: '化学试剂' },
                    { dictLabel: "科研仪器", dictValue: '科研仪器' },
                    { dictLabel: "纳米材料", dictValue: '纳米材料' },
                    { dictLabel: "定制需求", dictValue: '定制需求' },
                    // { dictLabel: "动物实验平台", dictValue: '动物实验平台' },
                    // { dictLabel: "生理生化平台", dictValue: '生理生化平台' },
                    // { dictLabel: "微生物平台", dictValue: '微生物平台' },
                    // { dictLabel: "医药平台", dictValue: '医药平台' },
                    // { dictLabel: "项目服务", dictValue: '项目服务' }
                ],
            }
        }
    }
}
</script>